import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    id: "worktrees",
    question: "How is this different from git worktrees?",
    answer:
      "A worktree gives you another checkout on the same machine. A runloft machine gives you another computer — its own filesystem, processes, ports, and database state — created from a template snapshot. Each agent can run your app, change dependencies, or break things without affecting the others.",
  },
  {
    id: "subscription",
    question: "Can I use my existing Claude Code or Codex subscription?",
    answer:
      "Yes. runloft runs the real Claude Code and Codex harness with your own subscription or API key. We don't resell tokens and we don't put our own harness between you and the agent.",
  },
  {
    id: "laptop",
    question: "Does the agent keep working if I close my laptop?",
    answer:
      "Yes — nothing runs on your laptop. Agents execute inside managed cloud machines, so threads keep going while you disconnect. Check in from the web, your phone, or the CLI whenever you want.",
  },
  {
    id: "what-runs",
    question: "What runs on a runloft machine?",
    answer:
      "A real Linux environment with dedicated vCPU and memory. If your project runs on a laptop, it runs on runloft — databases, dev servers, background workers and all.",
  },
  {
    id: "pricing",
    question: "How does pricing work?",
    answer:
      "You pay only for awake machine time, billed by the second. Idle machines sleep automatically and sleeping machines are free, so parallelism never turns into runaway costs.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="border-b border-[#1e293b]/50 py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="rl-reveal mb-12">
          <span className="font-mono text-xs uppercase tracking-widest text-[#22d3ee]">FAQ</span>
          <h2 className="mt-2 text-3xl font-bold text-white md:text-4xl">Questions, answered</h2>
        </div>

        <Accordion type="single" collapsible className="rl-reveal w-full" data-testid="faq-accordion">
          {FAQS.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={faq.id}
              className="border-[#1e293b]"
              data-testid={`faq-item-${faq.id}`}
            >
              <AccordionTrigger
                className="text-left text-sm font-semibold text-white hover:text-[#22d3ee] hover:no-underline"
                data-testid={`faq-trigger-${faq.id}`}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-[#94a3b8]">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
